import BaseAPI from '@/apis/base/baseApi';

export default class PUApi extends BaseAPI {
  apiName = 'PU';
}
